import React from 'react';
import TransactionPenaltyTable from './TransactionPenaltyTable';
import TransactionSummary from '../Components/TransactionSummary';

function TransactionPenaltyPage() {
  return (
    <section>
      <div class="my-7"></div>
      <TransactionSummary />
      <div class="my-7"></div>
      <TransactionPenaltyTable />
    </section>
  );
}

export default TransactionPenaltyPage;
